<!-- 标单制定中的form表单 -->
<div class="form">
  <div class="form-left">
    <div class="item" *ngFor="let leftItem of formLeftData">
      <p class="text">{{ leftItem['text'] | translate }} :</p>
      <p class="value" *ngIf="leftItem.value ==='demander'">{{ bidBaseInfor[leftItem.value] }}</p>
      <p class="value" *ngIf="leftItem.value ==='demanderTel'">{{ bidBaseInfor[leftItem.value] }}</p>

      <div *ngIf="leftItem.value === 'customerName'">
        <div class="customerName" *ngIf="editBudgetEstimatesStatus && !reviewResultIsReject; else elseTemplate1">
          <nz-select [nzShowArrow] [nzAllowClear] nzSize="small" nzPlaceHolder="{{ 'BidCreat.CustomerNamePlaceholder' | translate }}" 
            [(ngModel)]="bidBaseInfor.customerName" 
            (ngModelChange)="ngFormChange($event,'customerName')" 
            [nzOptions]="customerNameOption"> 
          </nz-select>
        </div>
        <ng-template #elseTemplate1>
          <p>{{ bidBaseInfor[leftItem.value] }}</p>
        </ng-template>
      </div>

      <div *ngIf="leftItem.value === 'projectName'">
        <div class="projectName" *ngIf="(makeBidEditStatus || editBudgetEstimatesStatus) && !reviewResultIsReject; else elseTemplate2">
          <input nz-input nzSize="small" placeholder="{{ 'BidCreat.EngineeringNamePlaceholder' | translate }}"
            nz-tooltip [nzTooltipTitle]="bidBaseInfor.projectName" nzTooltipPlacement="topRight"   
            [(ngModel)]="bidBaseInfor.projectName"
            (ngModelChange)="ngFormChange($event,'projectName')">
        </div>
        <ng-template #elseTemplate2>
          <p>{{ bidBaseInfor[leftItem.value] }}</p>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="form-middle">
    <div class="item" *ngFor="let middleItem of formMiddleData">
      <p class="text">{{ middleItem['text'] | translate }} :</p>
      <p *ngIf="middleItem.value==='quoteTel' || middleItem.value==='email';else elseTemplate"></p>
      <ng-template #elseTemplate>
        <p class="value">{{ bidBaseInfor[middleItem.value] }}</p>
      </ng-template>
    </div>
  </div>

  <div class="form-right">
    <div class="item" *ngFor="let rightItem of formRightData">
      <p class="text">{{ rightItem['text'] | translate }} :</p>
      <p class="value">{{ bidBaseInfor[rightItem.value] }}</p>
    </div>
  </div>
</div>